export enum ParamKey {
  HOMEPAGE_CATEGORY = 'tab',
  PAGE = 'page',
  SORT = 'sort',
  CATEGORY = 'cat',
  SEARCH = 'query',
  REGION = 'region',
  SAMPLE_PRICE = 'samplePrice',
  MOQ = 'moq',
  RECOMBEE_ID = 'recommId',
  FOCUS_ON_SEARCH = 'autofocus',
  SHOW_ONBOARDING = 'onboarding',
  TOKEN = 'token',
  PACKAGING_TAB = 'option',
  PATH = 'path',
  COUNTRY_CODE = 'countryCode',
  AVERAGE_REVIEW = 'averageReview',
  PRODUCTION_TIME = 'productionTime',
  ORDER_VOLUME = 'orderVolume',
  IGNORE_L3_CATEGORY_IDS = 'ignoreL3CategoryIds',
  L2_VERTICAL = 'vertical',
  L2_VERTICAL_NAME = 'vertical_name',
  L3_CATEGORY_ID = 'l3CategoryId',
  PRODUCTS_SEARCH_PAGE = 'productsSearchPage',
  SIGN_UP_REDIRECT = 'signupRedirect',
  VIDEO_ID = 'videoId',
}
